export const environment = {
  appEnv: 'dev',
  cognito: {
    userPoolId: 'us-east-2_JDUX7dvIV',
    userPoolWebClientId: '59vighc1jfv8se0ratipvo3ahq',
  },
  financialsApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/financials',
  sourcingApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sourcing',
  salesApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sales',
  productApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/product',
  aybApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/alimentos-bebidas',
  operationsApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/operations',
  cognitoDomain: 'https://explorandes.auth.us-east-2.amazoncognito.com',
  coreApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/core',
  mailingApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/mailing',
  isLocal: false,
};
